import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders, HttpInterceptor, HttpEvent, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { catchError, combineAll, finalize, map ,tap} from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../environments/environment'
import { Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';


@Injectable()
export class SharedService implements HttpInterceptor  {

    constructor(private http: HttpClient, public cookieService: CookieService,private spinner: NgxSpinnerService) { }
    //intercept added by rahul yadav on 19/07/2021 to show spinner till last response
    count = 0;
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //this._loading.setLoading(true, request.url);
        if (request.headers.get("Skip")=="true"){
            return next.handle(request)
        }
        else{
        this.spinner.show()
        this.count++;
        return next.handle(request)

            .pipe ( tap (

                   // event => console.log(event),

                   // error => console.log( error )

                ), finalize(() => {

                    this.count--;

                    if ( this.count == 0 ) 
                    this.spinner.hide()
                })
            );
        }   
      }


    // ADDED BY RAJAN SINGH ON 01/03/2019 -- FOR API TOKEN AUTHENTICATION
    public createHeader(SkipInterceptor:boolean=false) {
        var Authorization="";
        if(this.cookieService.get("SessionId")){
            Authorization = btoa(this.cookieService.get("SessionId"));
        }
        // SessionId
        const httpOptions = new HttpHeaders({
            'Content-Type': 'application/json',
            "Authorization": "Basic "+ Authorization,
            "Skip" :String(SkipInterceptor)
        });

        return httpOptions;
    }

    //Added By rahul yadav
    public createHeaderforimportExcel() {
        var Authorization;
        if(this.cookieService.get("SessionId")){
            Authorization = btoa(this.cookieService.get("SessionId"));
        }
        // SessionId
        const httpOptions = new HttpHeaders({
            "Authorization": "Basic "+ Authorization
        });

        return httpOptions;
     }

    

    public Post(FunctionName:any,Data?: any,SkipInterceptor:boolean=false) {
        let FullPath = environment.baseApiUrl + FunctionName;
        return this.http.post(FullPath, Data, { headers: this.createHeader(SkipInterceptor) });
    }

    //Added By rahul Yadav
     public ExcelPost(FunctionName:any,Data?: any) {
         let FullPath = environment.baseApiUrl + FunctionName;
         return this.http.post(FullPath,Data ,{ headers: this.createHeader(), responseType : "arraybuffer" });
     }
     public ImportExcelPost(FunctionName:any,Data?: any) {
        let FullPath = environment.baseApiUrl + FunctionName;
      
        return this.http.post(FullPath,Data ,{ headers: this.createHeaderforimportExcel(),responseType : "arraybuffer"});
    }



    public Get(FunctionName:any,Data?: any,SkipInterceptor:boolean=false) {
        let FullPath = environment.baseApiUrl + FunctionName;
        return this.http.get(FullPath, { params: Data, headers: this.createHeader(SkipInterceptor) , responseType:"json"});
    }

    public getDataSynchronous(FunctionName:any,Data?: any) {
        let FullPath = environment.baseApiUrl + FunctionName;
        return this.http.get(FullPath, { params: Data, headers: this.createHeader() , responseType:"json"}).toPromise();

    }

    public GetStaticContent(FilePath:any) {
        return this.http.get(FilePath,{responseType: 'text'});
    }





    // TO UPLOAD FILE WITH REPORT PROGRESS 
    public PostWithFile(FunctionName:any ,Data : FormData) {

        let FullPath = environment.baseApiUrl + FunctionName;
        var Authorization;
        if(this.cookieService.get("SessionId")){
            Authorization = btoa(this.cookieService.get("SessionId"));
        }

        const httpOptions = new HttpHeaders({
            "Authorization": "Basic "+ Authorization,
            // 'Content-Type': 'application/json',
            
        });
      
        return this.http.post(FullPath, Data,{headers: httpOptions, reportProgress:true ,observe:"events" })  
    }



    // ADDED BY RAJAN SINGH ON 10 MAY 2021 -->> TO DOWNLOAD FILE FROM AZURE 
    public DownloadFile(FunctionName:any,Data?: any) {
        let FullPath = environment.baseApiUrl + FunctionName;
        return this.http.post(FullPath,Data ,{ headers: this.createHeader(), responseType : "blob" });
    }


}
